import PocketBase from 'pocketbase';
import { POCKETBASE_URL } from '../config';

// Passing undefined when unconfigured keeps the SDK from silently pointing at
// the current origin; callers gate on PB_CONFIGURED before using it, so the
// app runs local-only rather than talking to the wrong host.
const pb = new PocketBase(POCKETBASE_URL || undefined);

// Avoid auto-cancellation of overlapping requests — the sync engine fires
// reads and writes in quick succession.
pb.autoCancellation(false);

export default pb;
